export const initializeMultipayment = (gmoShopId?: string | null) => {
  window.Multipayment?.init?.(gmoShopId ?? '')
}
